module.exports = __webpack_public_path__ + "static/media/coppenrath-wiese-x2.fca4f973.png";